import type { IconProps } from './Icons';

/**
 * § 353 — an icon is DECORATIVE unless it is told otherwise.
 *
 * Every icon in the core and app sets spreads its props through this. With nothing
 * naming it, the SVG gets `aria-hidden="true"`: almost every icon here sits beside a
 * text label or inside a named button, and an unhidden, unnamed `<svg>` is announced by
 * some screen readers as "graphic" with nothing after it. An icon that carries meaning
 * says so with `aria-label` / `aria-labelledby`, and is then exposed as `role="img"`
 * (the role an SVG needs for its name to be read reliably) unless the caller set a role.
 * An explicit `aria-hidden` — `true` or `false` — always wins, untouched.
 *
 * Lives outside `Icons.tsx` on purpose: `iconContract.test` renders every function that
 * module exports as an icon.
 */
export const decorative = (props: IconProps): IconProps => {
  if (props['aria-hidden'] !== undefined) return props;
  if (props['aria-label'] || props['aria-labelledby']) return { role: 'img', ...props };
  return { 'aria-hidden': true, ...props };
};
